/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 */

import InternetReachability from '@react-native-community/netinfo/src/internal/internetReachability';
import NativeInterface from './nativeInterface';

export function convertState(
  input
) {
  if (typeof input.isInternetReachable === 'boolean') {
    return input
  } else {
    return {
      ...input,
      isInternetReachable: InternetReachability.currentState(),
    }
  }
}

export function currentState() {
  return NativeInterface?.getCurrentState();
}

export default {
  convertState,
  currentState,
};